import React from "react";
import Title from "../../../components/Title/Title";

const KeynoteSpeaker2027page = () => {
    return (
        <div>
            <Title>Plenary Speakers</Title>
            <p>[COMING SOON]</p>
        </div>
    )
}

export default KeynoteSpeaker2027page
